import Handler from "../Handler";
class DealICMSuccessHandler extends Handler {
    // DealICMSuccess#
    // {
    //     "tourneyId": "rdxkr",
    //     "winnersDetails": {
    //         "naveen": {
    //             "bonus": 0,
    //             "win": 499.7
    //         },
    //         "myth974454": {
    //             "bonus": 0,
    //             "win": 500.3
    //         }
    //     }
    // }
    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processDealICMSuccessProtocol(receivedData);
    }
}
export default DealICMSuccessHandler;